import * as Sentry from '@sentry/react';

export const SENTRY_ENDPOINT = 'https://7e30acd5b30fbfdca4ab9304d9c6bbdd@o4508477779738624.ingest.de.sentry.io/4509349485609040';

export const configureSentry = (): void => {

  // Get environment from env variable or use appropriate default
  // In production builds, this should be set by CI/CD pipeline
  const environment = import.meta.env.VITE_APP_ENV || (import.meta.env.DEV ? 'dev' : 'prod');

  try {
    Sentry.init({
      dsn: SENTRY_ENDPOINT,
      integrations: [Sentry.browserTracingIntegration()],
      // Enable debug mode in all non-production environments
      debug: environment !== 'prod',
      environment: environment,
      release: `${import.meta.env.PACKAGE_NAME || 'watervergelijkingstool'}@${import.meta.env.PACKAGE_VERSION || '1.0.0'}`,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      sendDefaultPii: true,
    });
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};
